import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { vendorInvoiceAPI } from "../../helpers/api/vendorInvoice";

export const postVendorsInvoices = createAsyncThunk(
  "vendorInvoices/postVendorsInvoices",
  async (data, { rejectWithValue }) => {
    try {
      return await vendorInvoiceAPI.importVendors(data);
    } catch (error) {
      toast.error("Failed to import vendors", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to import vendors");
    }
  }
);
